<div class="d-flex pt-4 justify-content-end" style="gap: 20px;">
  <div class="col-12 p-0 m-0">
    <div class="form-content">
      <h2 class="page-title">{{ 'CLIENT_CREATION.SUMMARY.TITLE' | translate }}</h2>
      <p class="intro-text">
        {{ 'CLIENT_CREATION.SUMMARY.TEXT' | translate }}
      </p>

      <div class="row p-0 m-0">
        <div class="col-12 col-md-6 p-0 p-md-1 m-0">
          <h5>{{ 'CLIENT_CREATION.SUMMARY.CLIENT_MASTER_DATA_SECTION_TITLE' | translate }}</h5>
          <div class="p-fluid">
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.COMPANY_INFO.COMPANY_NAME' | translate }}:
              </div>
              <div class="col-7 p-0 m-0">{{ (companyInfoData$ | async).get('companyInfo.companyName').value || '-' }}
              </div>
            </div>
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.COMPANY_INFO.CORPORATE_FORM' | translate }}:
              </div>
              <div class="col-7 p-0 m-0">{{
                  (companyInfoData$ | async).get('companyInfo.corporateForm').value ?
                    ('COMPANY_SETTINGS.FORM.COMPANY_LEGAL_TYPE.' + (companyInfoData$ | async).get('companyInfo.corporateForm').value | translate) : '-'
                }}
              </div>
            </div>
            <div class="w-100"></div>
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.COMPANY_INFO.STREET' | translate }}:</div>
              <div class="col-7 p-0 m-0">{{ (companyInfoData$ | async).get('companyInfo.street').value || '-' }}</div>
            </div>
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.COMPANY_INFO.BUILDING_NUMBER' | translate }}:
              </div>
              <div
                class="col-7 p-0 m-0">{{ (companyInfoData$ | async).get('companyInfo.buildingNumber').value || '-' }}
              </div>
            </div>
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.COMPANY_INFO.ADDITIONAL_ADDRESSLINE' | translate }}:
              </div>
              <div
                class="col-7 p-0 m-0">{{ (companyInfoData$ | async).get('companyInfo.additionalAddressline').value || '-' }}
              </div>
            </div>
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.COMPANY_INFO.POSTOFFICE' | translate }}:
              </div>
              <div class="col-7 p-0 m-0">{{ (companyInfoData$ | async).get('companyInfo.postoffice').value || '-' }}
              </div>
            </div>
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.COMPANY_INFO.ZIP' | translate }}:</div>
              <div class="col-7 p-0 m-0">{{ (companyInfoData$ | async).get('companyInfo.zip').value || '-' }}</div>
            </div>
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.COMPANY_INFO.PLACE' | translate }}:</div>
              <div class="col-7 p-0 m-0">{{ (companyInfoData$ | async).get('companyInfo.place').value || '-' }}</div>
            </div>
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.COMPANY_INFO.COUNTRY' | translate }}:</div>
              <div class="col-7 p-0 m-0">{{ (countryName$ | async) || '-' }}</div>
            </div>
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.COMPANY_INFO.CANTON' | translate }}:</div>
              <div class="col-7 p-0 m-0">{{ (companyInfoData$ | async).get('companyInfo.canton').value || '-' }}</div>
            </div>
            @if (accountInfoData$ | async; as accountInfoData) {
            <div class="row p-0 m-0 mb-2 no-gutters" >
              <div class="col-12">
                <span class="p-link" (click)="showBusinessPurpose(accountInfoData.get('accountingInfo.businessPurpose').value)">
                    {{ 'CLIENT_CREATION.COMPANY_INFO.BUSINESS_PURPOSE' | translate }}
                </span>
              </div>
            </div>
            }
          </div>
        </div>
        <div class="col-12 col-md-6 p-0 p-md-1 m-0">
          <h5>{{ 'CLIENT_CREATION.SUMMARY.CLIENT_CONTACT_PERSON_SECTION_TITLE' | translate }}</h5>
          <div class="p-fluid">
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.COMPANY_INFO.ADDRESS_TITLE' | translate }}:
              </div>
              <div class="col-7 p-0 m-0">{{ (companyInfoData$ | async).get('companyInfo.title').value || '-' }}</div>
            </div>
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.COMPANY_INFO.FIRSTNAME' | translate }}:</div>
              <div class="col-7 p-0 m-0">{{ (companyInfoData$ | async).get('companyInfo.firstname').value || '-' }}
              </div>
            </div>
            <div class="w-100"></div>
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.COMPANY_INFO.LASTNAME' | translate }}:</div>
              <div class="col-7 p-0 m-0">{{ (companyInfoData$ | async).get('companyInfo.lastname').value || '-' }}</div>
            </div>
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.COMPANY_INFO.EMAIL' | translate }}:</div>
              <div class="col-7 p-0 m-0">{{ (companyInfoData$ | async).get('companyInfo.email').value || '-' }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row p-0 m-0">
        <div class="col-12 col-md-6 p-0 p-md-1 m-0">
          <h5>{{ 'CLIENT_CREATION.SUMMARY.CLIENT_ADVISOR_TITLE' | translate }}</h5>
          <div class="p-fluid">
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.ACCOUNTING_INFO.ONLINE_FIDUCIARY' | translate }}:</div>
              @if (accountInfoData$ | async) {
                <div class="col-7 p-0 m-0">{{ (onlineFiduciary$ | async)?.label || '-' }}
                </div>
              } @else {
                <div class="col-7 p-0 m-0">-</div>
              }
            </div>
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.ACCOUNTING_INFO.ONLINE_ACCOUNTANT' | translate }}:</div>
              @if (accountInfoData$ | async) {
                <div class="col-7 p-0 m-0">{{ (onlineAccountant$ | async)?.label || '-' }}
                </div>
              } @else {
                <div class="col-7 p-0 m-0">-</div>
              }
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 p-0 p-md-1 m-0">
          <h5>{{ 'CLIENT_CREATION.SUMMARY.ACCOUNTING_INFORMATION_TITLE' | translate }}</h5>
          <div class="p-fluid">
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.ACCOUNTING_INFO.CHART_OF_ACCOUNT_TYPE' | translate }}:</div>
              @if (accountInfoData$ | async) {
                <div class="col-7 p-0 m-0">{{ (chartOfAccount$ | async) || '-' }}
                </div>
              } @else {
                <div class="col-7 p-0 m-0">-</div>
              }
            </div>
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.ACCOUNTING_INFO.ACCOUNTING_PERIOD' | translate }}:</div>
              @if (accountInfoData$ | async) {
                <div class="col-7 p-0 m-0 d-flex">
                  <span>{{ (accountInfoData$ | async).get('accountingInfo.entryDate').value | date : ('GENERAL.DATE_FORMAT' | translate) }}
                  </span>
                  <span>{{' - '}}</span>
                  <span>{{ (accountInfoData$ | async).get('accountingInfo.exitDate').value | date : ('GENERAL.DATE_FORMAT' | translate) }}
                  </span>
                </div>
              } @else {
                <div class="col-7 p-0 m-0">-</div>
              }
            </div>
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'FORM.LANGUAGE' | translate }}:</div>
              @if (accountInfoData$ | async) {
                <div class="col-7 p-0 m-0">{{ (language$ | async) || '-' }}
                </div>
              } @else {
                <div class="col-7 p-0 m-0">-</div>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="row p-0 m-0">
        <div class="col-12 col-md-6 p-0 p-md-1 m-0">
          <h5>{{ 'CLIENT_CREATION.SUMMARY.RMA_SERVICES_TITLE' | translate }}</h5>
          <div class="p-fluid">
            @if((serviceInfoData$ | async); as serviceInfoData ) {
              @if (serviceInfoData.get('serviceInfo').valid) {
                <div class="row p-0 m-0 mb-2">
                  <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.SERVICE_INFO.BEGIN_RMA' | translate }}:
                  </div>
                    <div class="col-7 p-0 m-0">{{ (serviceInfoData.get('serviceInfo.rmaServiceStartDate').value | date : ('GENERAL.DATE_FORMAT' | translate)) || '-' }}
                    </div>
                </div>
                <div class="row p-0 m-0 mb-2">
                  <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.SUMMARY.SELECTED_PACKAGE' | translate }}:</div>
                    <div class="col-7 p-0 m-0">{{ serviceInfoData.get('serviceInfo.accountingPackage').value || '-' }}
                    </div>
                </div>
                <div class="row p-0 m-0 mb-2">
                  <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.SERVICE_INFO.TITLE.ADDITIONAL_SERVICES' | translate }}:
                  </div>
                  <div class="col-7 p-0 m-0">
                    {{ additionalServices || '-' }}
                  </div>
                </div>
                <div class="row p-0 m-0 mb-2">
                  <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.SUMMARY.PAYROLL_PACKAGE' | translate }}:</div>
                    <div class="col-7 p-0 m-0">{{ serviceInfoData.get('serviceInfo.payrollPackage').value || '-' }}
                    </div>
                </div>
                <div class="row p-0 m-0 mb-2">
                  <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.SERVICE_INFO.PAYROLL_PAYMENT_DAY' | translate }}:</div>
                    <div class="col-7 p-0 m-0">{{ serviceInfoData.get('serviceInfo.payrollPayDay').value || '-' }}
                    </div>
                </div>
                <div class="row p-0 m-0 mb-2">
                  <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.SERVICE_INFO.EXECUTE_PAYROLL_PAYMENTS' | translate }}:
                  </div>
                  <div class="col-7 p-0 m-0">{{ serviceInfoData.get('serviceInfo.executePayrollPayments').value ? ('GENERAL.YES' | translate) : ('GENERAL.NO' | translate) }}
                  </div>
                </div>
                <div class="row p-0 m-0 mb-2">
                  <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.SERVICE_INFO.EXECUTE_PAYROLL_PAYMENTS_BEFORE_BANK_HOLIDAYS' | translate }}:
                  </div>
                  <div class="col-7 p-0 m-0">{{ serviceInfoData.get('serviceInfo.executePayrollPaymentsBeforeBankHolidays').value ? ('GENERAL.YES' | translate) : ('GENERAL.NO' | translate) }}
                  </div>
                </div>
              } @else {
                <div class="row p-0 m-0 mb-2">
                  <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.SUMMARY.NO_SERVICE' | translate }}
                  </div>
                </div>
              }
            }
          </div>
        </div>
        <div class="col-12 col-md-6 p-0 p-md-1 m-0">
          <h5>{{ 'CLIENT_CREATION.SUMMARY.TAX_RELEVANT_INFORMATION' | translate }}</h5>
          <div class="p-fluid">
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.ACCOUNTING_INFO.VAT_LIABLE' | translate }}:</div>
              @if (accountInfoData$ | async) {
                <div class="col-7 p-0 m-0">{{ (accountInfoData$ | async).get('accountingInfo.vatLiable').value ? ('GENERAL.YES' | translate) : ('GENERAL.NO' | translate) }}
                </div>
              } @else {
                <div class="col-7 p-0 m-0">-</div>
              }
            </div>
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.ACCOUNTING_INFO.VAT_METHOD' | translate }}:</div>
              @if (accountInfoData$ | async) {
                <div class="col-7 p-0 m-0">{{ (vatMethod$ | async) || '-' }}
                </div>
              } @else {
                <div class="col-7 p-0 m-0">-</div>
              }
            </div>
            <div class="row p-0 m-0 mb-2">
              <div class="col-5 p-0 m-0">{{ 'CLIENT_CREATION.ACCOUNTING_INFO.VAT_BUSINESS_NUMBER' | translate }}:</div>
              @if (accountInfoData$ | async) {
                <div class="col-7 p-0 m-0">{{ (accountInfoData$ | async).get('accountingInfo.vatBusinessNumber').value || '-' }}
                </div>
              } @else {
                <div class="col-7 p-0 m-0">-</div>
              }
            </div>
          </div>
        </div>
      </div>
      <div formGroupName="summaryInfo"
           class="row p-0 m-0">
        <div class="col-12 col-md-6 p-0 p-md-1 m-0">
          <h5>{{ 'CLIENT_CREATION.SUMMARY.ADDITIONAL_MESSAGE_SECTION_TITLE' | translate }}</h5>
          <ibp-input-textarea class="col-12 p-0 m-0 pr-md-2 d-flex"
                              [autoResize]="false"
                              [placeholder]="'CLIENT_CREATION.SUMMARY.ADDITIONAL_MESSAGE_SECTION_PLACEHOLDER' | translate"
                              [rows]="13"
                              formControlName="info"></ibp-input-textarea>
        </div>
        <div class="col-12 col-md-6 p-0 p-md-1 m-0">
          <h5>
            {{ 'CLIENT_CREATION.SUMMARY.ADDITIONAL_DOCUMENTS_SECTION_TITLE' | translate }}{{ (uploadRequired$ | async) ? '*' : '' }}
          </h5>
          <ibp-upload-area-wrapper [uploadUrl]="null"
                                   [showUploadAction]="false"
                                   (filesSelectedBase64)="onSelectFiles($event)"></ibp-upload-area-wrapper>
        </div>
        <div class="col-12 col-md-6 p-0 p-md-1 m-0">
          <ibp-checkbox class="col-12 align-items-center"
                        [label]="'CLIENT_CREATION.SUMMARY.ORDER_CONFIRMATION'"
                        formControlName="isOrderConfirmed">
          </ibp-checkbox>
        </div>
      </div>
    </div>
    <div class="d-flex pt-4 justify-content-end" style="gap: 20px;">
      <ibp-button [label]="'BTN.BACK'"
                  [icon]="['fas', 'chevron-left']"
                  (onClick)="prevCallback.emit()">
      </ibp-button>
      <ibp-button [label]="'BTN.SUBMIT'"
                  [iconPos]="'right'"
                  [icon]="['fas', 'check']"
                  [disabled]="isSubmitDisabled() | async"
                  (onClick)="submitClientCallback.emit()">
      </ibp-button>
    </div>
  </div>
</div>
